import React, { useContext, useState } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonLabel,
  IonItem,
  IonButton,
  IonIcon,
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent,
  IonFooter,
  IonPage,
  IonContent,
  IonText,
  useIonViewWillEnter,
} from "@ionic/react";
import { AuthContext } from "context/auth.context";
import { AppContext } from "context/app.context";
import { cog } from "ionicons/icons";
import logo from "assets/logo.png";
import DomainCode from "./domainCode";
import { Domain } from "models/domain.model";
import { useHistory } from "react-router";
import { LoginResult } from "models/login.model";
import "./login.css";
import usePackageJson from "../../../package.json";
import { useHotkeys } from "react-hotkeys-hook";

export interface LoginIfoStorage {
  domain: Domain;
  loginResult: LoginResult;
}

const LoginForm = () => {
  const { login, isAuth } = useContext(AuthContext);
  const { setDomain, domain } = useContext(AppContext);
  const history = useHistory();
  const [isDomainModalOpen, setDomainModalOpen] = useState(false);
  const [form, setFormValidation] = useState({
    formValid: false,
    username: "",
    password: "",
    domain: "",
    errorCount: null,
    errors: {
      domain: "",
      username: "",
      password: "",
    },
  });

  const uiPackageJsonVersion = usePackageJson.version.split("-")[0];
  const uiPackageJsonBuild = usePackageJson.version.split("-")[1];

  const handleChange = (event: any) => {
    event.preventDefault();
    const { name, value } = event.target;
    let errors = form.errors;

    switch (name) {
      case "username":
        form.username = value;
        errors.username = value ? "" : "Username is not valid!";
        setFormValidation(form);
        break;
      case "password":
        form.password = value;
        setFormValidation(form);
        break;
      default:
        break;
    }
  };

  const countErrors = (errors: any) => {
    let count = 0;
    Object.values(errors).forEach(
      (val: any) => val.length > 0 && (count = count + 1)
    );
    return count;
  };

  const handleSubmit = () => {
    if (countErrors(form.errors) === 0) {
      login(form.username, form.password).then(auth => { 
        auth && history.push("/home") 
      });
    }
  };

  const openDomainModal = () => {
    setDomainModalOpen(true);
  };

  const closeDomainModal = () => {
    setDomainModalOpen(false);
  };

  useHotkeys('enter', handleSubmit, {
    enabled: window.location.pathname === '/login',
    enableOnTags: ["INPUT"]
  });

  useIonViewWillEnter(() => {
    if (isAuth) {
      history.push("/home");
    }
  }, [isAuth, history]);

  return (
    <IonPage>
      <IonContent>
        <form className="form-container full-height">
          <IonGrid className="ion-no-padding full-height">
            <IonRow class="ion-justify-content-center ion-align-items-center full-height">
              <IonCard className="card-container">
                <IonCardHeader>
                  <img alt="ipro-logo" width="70" height="70" src={logo} />
                  <IonCardSubtitle>Welcome to</IonCardSubtitle>
                  <IonCardTitle>iPro Questionnaire</IonCardTitle>
                </IonCardHeader>
                {domain.Code && (
                  <IonCardContent>
                    <IonGrid className="ion-no-padding">
                      <IonRow>
                        <IonCol push="1" size="10">
                          <IonItem lines="none">
                            <IonLabel
                              className="input-title"
                              position="stacked"
                            >
                              Username
                            </IonLabel>
                            <IonInput
                              className="ipro-input"
                              type="text"
                              name="username"
                              id="username"
                              onIonChange={(e) => handleChange(e)}
                              clearInput
                            ></IonInput>
                          </IonItem>
                        </IonCol>
                      </IonRow>
                      <IonRow className="ion-padding-vertical">
                        <IonCol push="1" size="10">
                          <IonItem lines="none">
                            <IonLabel
                              className="input-title"
                              position="stacked"
                            >
                              Password
                            </IonLabel>
                            <IonInput
                              className="ipro-input"
                              type="password"
                              name="password"
                              id="password"
                              onIonChange={(e) => handleChange(e)}
                              clearInput
                            ></IonInput>
                          </IonItem>
                        </IonCol>
                      </IonRow>
                      <IonRow className="ion-padding-top">
                        <IonCol size="12" className="login-btn-container">
                          <IonButton
                            className="ipro-btn"
                            color="primary"
                            expand="block"
                            onClick={(e) => {
                              handleSubmit();
                            }}
                          >
                            Log in
                          </IonButton>
                        </IonCol>
                      </IonRow>
                    </IonGrid>
                  </IonCardContent>
                )}
                <IonFooter className="ion-no-border">
                  <IonRow>
                    <IonCol size="6">
                      <DomainCode
                        CloseModal={closeDomainModal}
                        fnToSetDomain={setDomain}
                        fnToOpenModal={openDomainModal}
                        isModelOpen={isDomainModalOpen}
                      ></DomainCode>
                      <IonButton
                        onClick={() => openDomainModal()}
                        className="ipro-btn"
                        color="primary"
                        fill="clear"
                      >
                        <IonIcon slot="start" icon={cog} />
                        {domain?.Name}
                      </IonButton>
                    </IonCol>
                    <IonCol
                      size="6"
                      className="d-flex justify-content-center align-items-center"
                    >
                      <IonText>
                        v({uiPackageJsonVersion}) b({uiPackageJsonBuild})
                      </IonText>
                    </IonCol>
                  </IonRow>
                </IonFooter>
              </IonCard>
            </IonRow>
          </IonGrid>
        </form>
      </IonContent>
    </IonPage>
  );
};

export default LoginForm;
